import styled from 'styled-components';

const commonGameAssetsFolder =
  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/commonGameAssets';

export const StyledSoundPlayingIcon = styled.div.attrs(
  ({ responsiveTransform, originalSize }) => {
    return {
      style: {
        '--width': `${responsiveTransform.width}px`,
        '--height': `${responsiveTransform.height}px`,

        '--imageWidth': `${originalSize.width}px`,
        '--imageHeight': `${originalSize.height}px`,
        '--x': `${responsiveTransform.x}px`,
        '--y': `${responsiveTransform.y}px`,
        '--scaleX': responsiveTransform.scaleX,
        '--scaleY': responsiveTransform.scaleY,
      },
    };
  }
)`
  position: absolute;
  width: calc(var(--width) + 10px);
  height: calc(var(--height) + 10px);
  transform: translate(var(--x), var(--y));
  z-index: 99;
  background: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  .audio-playing {
    transform: scale(var(--scaleX), var(--scaleY));
    width: var(--imageWidth);
    height: var(--imageHeight);
    background: url('${commonGameAssetsFolder}/audio_icon_playing_2.svg');
    background-size: calc(var(--imageWidth) * 5) var(--imageWidth);
    animation: soundPlaying steps(5) 0.4s infinite;
    overflow: hidden;
  }

  @keyframes soundPlaying {
    100% {
      background-position: calc(-5 * var(--imageWidth));
    }
  }
`;
